import React from "react";
import UnloadingPriorityGlobal from "./globalView/unloadingPriorityGlobal";
const UnloadingPriorityLossToAction = () => {
    return (
       
        <UnloadingPriorityGlobal />
        
    );
};

export default UnloadingPriorityLossToAction;